var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselPrevIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    transform: "matrix(-1 0 0 1 40 0)",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "#D8DFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 20.7L17.3 26.7C17.5 26.9 17.7 27 18 27C18.3 27 18.5 26.9 18.7 26.7C19.1 26.3 19.1 25.7 18.7 25.3L14.4 21H28C28.6 21 29 20.6 29 20C29 19.4 28.6 19 28 19H14.4L18.7 14.7C19.1 14.3 19.1 13.7 18.7 13.3C18.3 12.9 17.7 12.9 17.3 13.3L11.3 19.3C11.2 19.4 11.1 19.5 11.1 19.6C11 19.8 11 20.1 11.1 20.4C11.1 20.5 11.2 20.6 11.3 20.7Z",
    fill: "#3876BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25325_14292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 18,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 20.7L17.3 26.7C17.5 26.9 17.7 27 18 27C18.3 27 18.5 26.9 18.7 26.7C19.1 26.3 19.1 25.7 18.7 25.3L14.4 21H28C28.6 21 29 20.6 29 20C29 19.4 28.6 19 28 19H14.4L18.7 14.7C19.1 14.3 19.1 13.7 18.7 13.3C18.3 12.9 17.7 12.9 17.3 13.3L11.3 19.3C11.2 19.4 11.1 19.5 11.1 19.6C11 19.8 11 20.1 11.1 20.4C11.1 20.5 11.2 20.6 11.3 20.7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25325_14292)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 8H8V32H32V8Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselPrevIcon);
export default __webpack_public_path__ + "static/media/CarouselPrevIcon.60236fbfa2ab7e01e4160ee1ce990fd1.svg";
export { ForwardRef as ReactComponent };